import type { MonthTitleComponentProps } from "rn-calendar-component";

import { Block, Typography } from "@stepapp/ui";

const CalendarMonthTitle = ({ title, theme }: MonthTitleComponentProps) => {
  return (
    <Block style={theme?.container}>
      <Typography center variant="bodyBold">
        {title}
      </Typography>
    </Block>
  );
};

export default CalendarMonthTitle;
